import {useIntl} from 'react-intl'
import BreadCrumb from '../../../_metronic/layout/components/breadcrumb'
import AverageAnalytics from '../component/sections/AverageAnalytics'
import RateAnalytics from '../component/sections/RateAnalytics'
import TimeLineChart from '../component/components/timeLineChart'
import TotalRevenue from '../component/sections/TotalRevenue'
import NumberOfOrders from '../component/sections/NumberOfOrders'
/* import ReferralRevenue from '../component/sections/ReferralRevenue'
import ReferredOrders from '../component/sections/ReferredOrders' */
import {
  useGetMemberAnalytics,
  useGetAverageAnalytics,
  useGetRateAnalytics,
  useGetPointAnalytics,
  useGetRevenueTimeBandAnalytics,
  useGetRevenueAnalytics,
  useGetOrderAnalytics,
  useGetTransactionAnalytics,
} from '../context/useGetAnalytics'
import {useState} from 'react'
import RecentTrx from '../component/sections/RecentTrx'

export default function Reports() {
  const intl = useIntl()
  const [period, setPeriod] = useState(3)
  const {data: memberAnalytics, isLoading: isLoadingMemberAnalytics} = useGetMemberAnalytics(period)
  const {data: averageAnalytics, isLoading: isLoadingAverageAnalytics} =
    useGetAverageAnalytics(period)
  const {data: rateAnalytics, isLoading: isLoadingRateAnalytics} = useGetRateAnalytics(period)
  // const {data: pointAnalytics, isLoading: isLoadingPointAnalytics} = useGetPointAnalytics(period)
  const {data: revenueTimeBandAnalytics, isLoading: isLoadingRevenueTimeBandAnalytics} =
    useGetRevenueTimeBandAnalytics(period)
  const {data: revenueAnalytics, isLoading: isLoadingRevenueAnalytics} =
    useGetRevenueAnalytics(period)
  const {data: orderAnalytics, isLoading: isLoadingOrderAnalytics} = useGetOrderAnalytics(period)
  const {data: transactionAnalytics, isLoading: isLoadingTransactionAnalytics} =
    useGetTransactionAnalytics(period)

  const periodText = () => {
    switch (period) {
      case 1:
        return intl.formatMessage({id: 'GLOBAL.IN_TODAY'})
      case 3:
        return intl.formatMessage({id: 'GLOBAL.IN_LAST_WEEK'})
      case 4:
        return intl.formatMessage({id: 'GLOBAL.IN_LAST_30_DAYS'})
      case 5:
        return intl.formatMessage({id: 'GLOBAL.IN_LAST_90_DAYS'})
      default:
        return ''
    }
  }

  return (
    <>
      <div className='d-flex justify-content-between align-items-center'>
        <BreadCrumb currentPage={intl.formatMessage({id: 'REPORT'})} />
        <select
          className='form-select form-select-solid w-150px w-md-200px bg-white border-light'
          data-control='select2'
          data-placeholder='Select an option'
          data-hide-search='true'
          value={period.toString()}
          disabled={
            isLoadingMemberAnalytics ||
            isLoadingAverageAnalytics ||
            isLoadingRateAnalytics ||
            isLoadingRevenueTimeBandAnalytics ||
            isLoadingRevenueAnalytics ||
            isLoadingOrderAnalytics ||
            isLoadingTransactionAnalytics
          }
          onChange={(e) => {
            setPeriod(Number(e.target.value))
          }}
        >
          <option value='5'>{intl.formatMessage({id: 'GLOBAL.LAST_90_DAYS'})}</option>
          <option value='4'>{intl.formatMessage({id: 'GLOBAL.LAST_30_DAYS'})}</option>
          <option value='3'>{intl.formatMessage({id: 'GLOBAL.LAST_WEEK'})}</option>
          <option value='1'>{intl.formatMessage({id: 'GLOBAL.TODAY'})}</option>
        </select>
      </div>

      <div className='tab-content mt-10' id='myTabContent'>
        <div className='tab-pane fade active show' role='tabpanel'>
          <div className='card-body position-relative pt-0'>
            <div className='tab-content' id='myTabContent'>
              <AverageAnalytics
                member={memberAnalytics}
                average={averageAnalytics}
                period={periodText()}
                isLoading={isLoadingAverageAnalytics}
              />
              {rateAnalytics?.analyticsRateDetails?.length > 0 && (
                <RateAnalytics rate={rateAnalytics} isLoading={isLoadingRateAnalytics} />
              )}
              <TimeLineChart
                revenue={revenueAnalytics}
                revenueTimeBand={revenueTimeBandAnalytics}
                isLoading={isLoadingRevenueAnalytics || isLoadingRevenueTimeBandAnalytics}
              />
              <div
                className='separator my-10'
                style={{
                  borderBottom: '1px solid #e0e0e0',
                }}
              ></div>
              <div className='d-flex w-100  gap-5 flex-column flex-md-row mt-5'>
                <div className='card w-100'>
                  <TotalRevenue
                    revenue={revenueAnalytics}
                    period={periodText()}
                    isLoading={isLoadingRevenueAnalytics}
                  />
                </div>

                <div className='card w-100'>
                  <NumberOfOrders
                    order={orderAnalytics}
                    period={periodText()}
                    isLoading={isLoadingOrderAnalytics}
                  />
                </div>
              </div>

              <div className='tab-pane fade active show' role='tabpanel'>
                <div className='card-body position-relative pt-0'>
                  <div className='tab-content' id='myTabContent'>
                    <div className='tab-pane fade active show' role='tabpanel'>
                      <div>
                        <div
                          className='separator my-10'
                          style={{borderBottom: '1px solid #e0e0e0'}}
                        ></div>
                        <div className='d-flex justify-content-between gap-5 mt-5'>
                          <div className='w-100'>
                            <RecentTrx
                              data={transactionAnalytics?.transactionData}
                              loading={isLoadingTransactionAnalytics}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
